import { motion } from "framer-motion";
import React from "react";

const QuemSomos = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <head>
        <title>Quem Somos - Dominus Eletrônicos</title>
        <meta name="description" content="Conheça a Dominus, sua loja de eletrônicos com os melhores produtos e atendimento" />
      </head>

      <main className="container mx-auto px-4 py-8">
        {/* Cabeçalho com animação */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl font-bold text-green-600 mb-4">Dominus Eletrônicos</h1>
          <div className="w-24 h-1 bg-green-500 mx-auto"></div>
        </motion.div>

        {/* Seção Quem Somos */}
        <motion.section
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mb-16"
        >
          <h2 className="text-3xl font-semibold text-green-700 mb-6">Quem Somos</h2>
          <div className="bg-white rounded-lg shadow-lg p-8">
            <p className="text-lg text-gray-700 mb-4">
              Na Dominus, tecnologia é mais do que um produto — é uma experiência. Fundada com o propósito de conectar pessoas ao que há de mais moderno e eficiente no mundo dos eletrônicos, nossa missão é oferecer soluções inovadoras com qualidade, segurança e um atendimento que coloca o cliente em primeiro lugar.
            </p>
            <p className="text-lg text-gray-700 mb-4">
              Trabalhamos com uma ampla variedade de produtos, desde smartphones, acessórios e computadores até itens de automação e eletrônicos para o dia a dia. Cada item em nosso catálogo é cuidadosamente selecionado para garantir desempenho, durabilidade e excelente custo-benefício.
            </p>
            <p className="text-lg text-gray-700">
              Mais do que vender, buscamos construir confiança. Por isso, prezamos por um atendimento transparente, suporte técnico qualificado e uma política de pós-venda que respeita você. Seja no ambiente físico ou online, na Dominus você encontra o melhor da tecnologia com a atenção que merece.
            </p>
          </div>
        </motion.section>

        {/* Destaques */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="grid md:grid-cols-3 gap-8 mb-16"
        >
          <div className="bg-green-600 text-white rounded-lg p-6 shadow-lg transform hover:scale-105 transition duration-300">
            <h3 className="text-xl font-bold mb-3">Missão</h3>
            <p>Oferecer tecnologia de qualidade com atendimento excepcional, conectando pessoas às melhores soluções eletrônicas.</p>
          </div>
          
          <div className="bg-green-700 text-white rounded-lg p-6 shadow-lg transform hover:scale-105 transition duration-300">
            <h3 className="text-xl font-bold mb-3">Visão</h3>
            <p>Ser referência em eletrônicos, reconhecida pela excelência em produtos e relacionamento com o cliente.</p>
          </div>
          
          <div className="bg-green-800 text-white rounded-lg p-6 shadow-lg transform hover:scale-105 transition duration-300">
            <h3 className="text-xl font-bold mb-3">Valores</h3>
            <p>Transparência, qualidade, inovação e respeito ao cliente são os pilares do nosso negócio.</p>
          </div>
        </motion.div>

        {/* Slogan final */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="text-center"
        >
          <h2 className="text-4xl font-bold text-green-600 mb-4">Dominus</h2>
          <p className="text-xl text-gray-600">Tecnologia que domina o seu dia a dia.</p>
        </motion.div>
      </main>
    </div>
  );
};

export default QuemSomos;